// 配置模块
export default [
  {
    path: '/configuration/classGroup',
    component: resolve => require(['@/pages/configuration/classGroup.vue'], resolve),
    name: 'classGroup',
    meta: {
      title: '院系专业配置'
    }
  },
  {
    path: '/configuration/candidate',
    component: resolve => require(['@/pages/configuration/candidate.vue'], resolve),
    name: 'candidate',
    meta: {
      title: '考生信息配置'
    }
  },
  {
    path: '/configuration/otherConfig',
    component: resolve => require(['@/pages/configuration/otherConfig.vue'], resolve),
    name: 'otherConfig',
    meta: {
      title: '考生信息配置'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/configuration.js